class PulseTopPicks extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll('[role="tabpanel"]');
    this.arrows = this.querySelectorAll('.pulse-top-picks__arrow');
  }

  connectedCallback() {
    this.initTabs();
    this.initArrows();
    this.resizeObserver = new ResizeObserver(() => this.updateArrowStateAll());
    this.resizeObserver.observe(this);
    this.updateArrowStateAll();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  initTabs() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.switchTab(tab));
      tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
    });
  }

  switchTab(targetTab) {
    const targetIndex = targetTab.dataset.tabIndex;
    if (targetIndex === undefined) return;

    this.tabs.forEach((tab, index) => {
      const isActive = String(index) === targetIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel, index) => {
      const isActive = String(index) === targetIndex;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    this.updateArrowStateAll();
  }

  handleKeydown(event, currentTab) {
    const tabsArray = Array.from(this.tabs);
    const currentIndex = tabsArray.indexOf(currentTab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % tabsArray.length;
    } else if (event.key === 'ArrowLeft') {
      nextIndex = (currentIndex - 1 + tabsArray.length) % tabsArray.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = tabsArray.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    const nextTab = tabsArray[nextIndex];
    this.switchTab(nextTab);
    nextTab.focus();
  }

  initArrows() {
    this.arrows.forEach((arrow) => {
      arrow.addEventListener('click', () => this.scrollTrack(arrow));
    });

    this.querySelectorAll('.pulse-top-picks__track').forEach((track) => {
      track.addEventListener('scroll', () => this.updateArrowState(track), { passive: true });
    });
  }

  scrollTrack(arrow) {
    const trackId = arrow.dataset.track;
    const track = document.getElementById(trackId);
    if (!track) return;

    const direction = arrow.dataset.dir === 'next' ? 1 : -1;
    const slide = track.querySelector('.pulse-top-picks__slide');
    const gap = parseInt(getComputedStyle(track).gap || 0, 10);
    const step = slide ? slide.getBoundingClientRect().width + gap : 320;

    track.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  updateArrowStateAll() {
    this.panels.forEach((panel) => {
      const track = panel.querySelector('.pulse-top-picks__track');
      if (track) this.updateArrowState(track);
    });
  }

  updateArrowState(track) {
    const wrapper = track.closest('.pulse-top-picks__slider-wrapper');
    if (!wrapper) return;

    const prev = wrapper.querySelector('.pulse-top-picks__arrow--prev');
    const next = wrapper.querySelector('.pulse-top-picks__arrow--next');
    const maxScroll = track.scrollWidth - track.clientWidth;

    if (prev) prev.disabled = track.scrollLeft <= 0;
    if (next) next.disabled = track.scrollLeft >= maxScroll - 1 || maxScroll <= 0;
  }
}

customElements.define('pulse-top-picks', PulseTopPicks);
